import { type ReactNode } from 'react';

const B = 'animate-pulse rounded-sm bg-white/[0.05]';

function ProfileSkeleton(): ReactNode {
  return (
    <div className="flex items-start gap-md">
      <div className={`h-10 w-10 shrink-0 rounded-full ${B}`} />
      <div className="min-w-0 flex-1">
        <div className="h-5">
          <div className={`h-3.5 w-28 ${B}`} />
        </div>
        <div className="h-4">
          <div className={`h-3 w-20 ${B}`} />
        </div>
        <div className="mt-sm h-5">
          <div className={`h-3 w-full ${B}`} />
        </div>
      </div>
    </div>
  );
}

function FieldSkeleton(): ReactNode {
  return (
    <div>
      <div className="h-3">
        <div className={`h-2.5 w-12 ${B}`} />
      </div>
      <div className="mt-0.5 h-5">
        <div className={`h-3.5 w-14 ${B}`} />
      </div>
    </div>
  );
}

export function CreatorDetailSkeleton(): ReactNode {
  return (
    <div className="space-y-base">
      <ProfileSkeleton />
      <div className="border-t border-white/[0.06] pt-base">
        <div className="grid grid-cols-3 gap-base">
          {Array.from({ length: 7 }, (_, i) => (
            <FieldSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
